/* Strips stale free-gift lines out of the cart.
 *
 * The gifts used to be added here as real $0 lines. They are part of the pack
 * now (see snippets/purogy-cart-gifts.liquid for why), and the discount that
 * held them at $0 is gone, so any of these still sitting in a shopper's cart
 * from an earlier visit would be charged at full price. This removes them.
 *
 * The gift products are drafted, so Shopify would drop these lines at checkout
 * anyway; doing it here means the shopper never sees a $20 jar on their total.
 *
 * Once no live cart can still be carrying one — carts expire after 14 days —
 * this file and its script tag can go.
 */
(function () {
  var GIFT_IDS = ['47003810955318', '47001654984758', '47001655017526'];

  var busy = false;

  /* Capture fetch before the interceptor below wraps it, so this file's own
     cart calls do not re-trigger it. */
  var nativeFetch = window.fetch.bind(window);

  function removeStaleGifts() {
    if (busy) return Promise.resolve();
    busy = true;

    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var stale = cart.items.filter(function (item) {
          return GIFT_IDS.indexOf(String(item.variant_id)) !== -1;
        });
        if (!stale.length) return false;

        /* One at a time: each change renumbers the remaining lines. */
        return stale
          .reduce(function (chain, item) {
            return chain.then(function () {
              return nativeFetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 }),
              });
            });
          }, Promise.resolve())
          .then(function () {
            return true;
          });
      })
      .catch(function () {
        return false;
      })
      .then(function (mutated) {
        busy = false;
        return mutated ? rerender() : null;
      });
  }

  /* Redraw the cart surfaces, since the lines were pulled behind their back. */
  function rerender() {
    var cartUrl = window.routes ? window.routes.cart_url : '/cart';
    var jobs = [];

    if (document.querySelector('cart-drawer-items')) {
      jobs.push(
        nativeFetch(cartUrl + '?section_id=cart-drawer')
          .then(function (r) {
            return r.text();
          })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            ['cart-drawer-items', '.purogy-cartd__footer'].forEach(function (selector) {
              var target = document.querySelector(selector);
              var source = html.querySelector(selector);
              if (target && source) target.replaceWith(source);
            });
          })
      );
    }

    var pageItems = document.querySelector('cart-items');
    if (pageItems && typeof pageItems.onCartUpdate === 'function') {
      jobs.push(pageItems.onCartUpdate());
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      jobs.push(
        nativeFetch(cartUrl + '?section_id=cart-icon-bubble')
          .then(function (r) {
            return r.text();
          })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            var source = html.querySelector('.shopify-section');
            if (source) bubble.innerHTML = source.innerHTML;
          })
      );
    }

    return Promise.all(jobs).catch(function () {});
  }

  /* A stale gift can only reappear if something restores an old cart, so a
     check after each external cart write is enough. */
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mutates =
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1;
    var promise = nativeFetch.apply(this, arguments);
    if (!mutates) return promise;
    return promise.then(function (response) {
      setTimeout(removeStaleGifts, 60);
      return response;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeStaleGifts);
  } else {
    removeStaleGifts();
  }
})();
